import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { setAnswersAction } from 'root-redux/actions/common'
import { sendUserAnswersAction } from 'root-redux/actions/user'

import { useGetPageInfo } from 'hooks/useGetPageInfo'

import { IStepInfo, TAnswer } from 'models/common.model'

import { eventLogger } from 'services/eventLogger.service'

import { goTo } from 'browser-history'
import { CustomPageId } from 'page-constants'

export const useNextStep = ({
  pageId,
  question,
  nextPagePath,
  isFirstPage,
  isSkippedStep,
}: IStepInfo): ((userAnswer: TAnswer, analyticsAnswer?: TAnswer) => void) => {
  const dispatch = useDispatch()
  const { isFirstQuestionPage } = useGetPageInfo()
  const shouldLogFirstPageCompleted = isFirstPage ?? isFirstQuestionPage

  return useCallback(
    (userAnswer: TAnswer, analyticsAnswer?: TAnswer) => {
      dispatch(
        setAnswersAction({
          answers: userAnswer,
          pageId,
        }),
      )
      dispatch(sendUserAnswersAction())

      eventLogger.logQuestion({
        question,
        answers: analyticsAnswer || userAnswer,
        skipScreen: isSkippedStep,
      })

      const biAnswer = analyticsAnswer || userAnswer
      if (pageId === CustomPageId.GENDER) {
        eventLogger.logBiUserGender(biAnswer)
      } else if (pageId === CustomPageId.AGE) {
        eventLogger.logBiUserAge(biAnswer)
      }

      if (shouldLogFirstPageCompleted) {
        eventLogger.logFirstPageCompleted({
          question,
          answers: userAnswer,
        })
      }

      goTo(nextPagePath)
    },
    [
      dispatch,
      isSkippedStep,
      pageId,
      question,
      shouldLogFirstPageCompleted,
      nextPagePath,
    ],
  )
}
